import {
    MILITARY_VARIANT,
    STC_VARIANT,
    collection,
    isMilitaryEnabled,
    parentTypeFor,
} from "../_variants/index.js";
import {
    addConcession,
    cancelConcession,
    editConcession,
    linkConcession,
    signoffConcession
} from "./actions";

import store from "../../../store";

function warning(key) {
    let item = store.state[key];
    if (!item || item.Cancelled === true) return false;
    let warningMessage = "";
    if (item && item.Signedoff === false) {
        warningMessage = warningMessage += `${item.Number} is not signedoff.<br>`;
    }
    return warningMessage === "" ? false : warningMessage;
}

const cellClassRules = {
    "text-orange font-bold": params => {
        return warning(params.data);
    }
}

const headers = [{
    "headerName": "Number",
    "field": "Number",
    cellClassRules
}, {
    "headerName": "Comment",
    "field": "Comment",
    cellClassRules
}, {
    "headerName": "Signed Off",
    "field": "Signedoff",
    "type": "bool",
    cellClassRules
}];

/**
 * Build the attachable-table descriptor for the Concession register that
 * matches the supplied variant.
 *
 * @param {import("../_variants/index.js").Variant} variant
 */
export const makeConcessionAttachable = (variant) => {
    const isMilitary = variant.key === "military";
    const labelSingular = isMilitary ? "Military Concession" : "Concession";
    const labelPlural = isMilitary ? "Military Concessions" : "Concessions";
    const conParentType = parentTypeFor(variant, "Concessions");
    const conCollection = collection(variant, "Concessions");

    const actions = [{
        "label": `Add ${labelSingular}`,
        "action": addConcession,
        show({ meta }) {
            return [["DesignChanges", "FlightConditions", "MilitaryDesignChanges", "MilitaryFlightConditions"].includes(meta?.ParentType), `${labelPlural} cannot be added to a Document, they must be linked.`]
        }
    }, {
        "label": `Link ${labelSingular}`,
        "action": linkConcession
    }];

    const rowActions = [{
        "label": `View ${labelSingular}`,
        action({ router, rowItem }) {
            router.push(`/Database/${conParentType}/${rowItem.ID}`)
        }
    }, {
        "label": `Update ${labelSingular}`,
        "break": true,
        "action": editConcession
    }, {
        "label": `Signoff ${labelSingular}`,
        "action": signoffConcession
    }, {
        "label": `Cancel ${labelSingular}`,
        "break": true,
        "action": cancelConcession,
        "class": "text-red"
    }];

    return {
        "label": labelPlural,
        "key": conParentType,
        "location": `${conCollection}/`,
        actions,
        rowActions,
        headers,
        warn({ items }) {
            let warningMessage = items.map(warning).filter(i => i !== false).join("");
            return [warningMessage !== "", warningMessage];
        }
    };
};

export const concessionAttachable = makeConcessionAttachable(STC_VARIANT);
export const militaryConcessionAttachable = isMilitaryEnabled() ? makeConcessionAttachable(MILITARY_VARIANT) : null;

export default concessionAttachable;
